import {createSelector} from 'reselect';

import {getGuestErrorObject} from '../utils/guests';
import {getTranslations, getTripData} from './store';
import {getListingHouseRules, getSleeps, getPetsAllowed} from './listing';
import {
    getChildrenAllowedFromHouseRules,
    getMaxAdultsFromHouseRules,
    getMaxChildrenFromHouseRules
} from '../utils/guests';

const getChildrenAllowed = createSelector(
    [getListingHouseRules],
    (houseRules) => {
        return getChildrenAllowedFromHouseRules({houseRules});
    }
);

const getMaxAdults = createSelector(
    [getListingHouseRules, getSleeps],
    (houseRules, sleeps) => {
        return getMaxAdultsFromHouseRules({houseRules, sleeps});
    }
);

const getMaxChildren = createSelector(
    [getListingHouseRules, getSleeps],
    (houseRules, sleeps) => {
        return getMaxChildrenFromHouseRules({houseRules, sleeps});
    }
);

const getGuestsError = createSelector(
    [getSleeps, getPetsAllowed, getTranslations, getTripData, getMaxAdults, getMaxChildren],
    (sleeps, petsAllowed, translations, tripData, maxAdults, maxChildren) => {
        const {adults, children, hasPets} = tripData;

        return getGuestErrorObject({
            adults,
            children,
            hasPets,
            maxAdults,
            maxChildren,
            petsAllowed,
            sleeps,
            translations
        });
    }
);

export {getChildrenAllowed, getMaxAdults, getMaxChildren, getGuestsError};
